import { Menu } from 'antd';
import { NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Import styles
import { ButtonStyled, MenuStyled, LogoutItem, ButtonLogout, ButtonsContainer, ButtonText } from './styles';
import { ItemStyled } from 'components/elements/molecules/dropdown/styles';

// Import utilities
import { useAuth } from 'components/utilities';

// Import actions
import { subscriberLogout } from 'store/features/subscriber/thunk';

// Import variables
import { filterOperatorLinks } from 'helpers/operators';

// Import routes
import { NAV_LINKS } from 'components/routes/user_routes/routes';
import { AuthPaths } from 'components/routes/auth/routes';

// Import hooks
import { useAppSelector, useAppDispatch } from 'store/hooks';

const filteredLinks = NAV_LINKS.filter(filterOperatorLinks);

export const useNavDropdown = ({ isMobile, isOpen, toggle }) => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const login = useAppSelector(({ subscriber }) => subscriber.details?.login ?? '');
	const { isAuth } = useAuth();

	const handleSignOut = () => {
		dispatch(subscriberLogout());
	};

	const handleDropdownClick = () => {
		isMobile && isOpen && toggle();
	};

	const menu = (
		<MenuStyled isMobile={isMobile}>
			{filteredLinks.map(({ path, translation, key }) => (
				<ItemStyled key={key} isMobile={isMobile}>
					<NavLink to={path} activeClassName="active-drop-nav">
						{t(`user_profile_${translation}`)}
					</NavLink>
				</ItemStyled>
			))}
			<Menu.Divider />
			<LogoutItem key="wyloguj">
				<ButtonLogout onClick={handleSignOut} isMobile={isMobile}>
					{t('common_static_btn_sign_out')}
				</ButtonLogout>
			</LogoutItem>
		</MenuStyled>
	);

	const authButtons = (
		<ButtonsContainer isMobile={isMobile}>
			<ButtonStyled as={Link} to={AuthPaths.Login} modifiers="reject">
				<ButtonText>{t('login_already_have_an_account')}</ButtonText>
			</ButtonStyled>

			<ButtonStyled as={Link} to={AuthPaths.Registration} modifiers="primaryVod">
				<ButtonText>{t('common_main_nav_register_button')}</ButtonText>
			</ButtonStyled>
		</ButtonsContainer>
	);

	const unauthorizedMenu = <MenuStyled isMobile={isMobile}>{authButtons}</MenuStyled>;

	return {
		menu,
		unauthorizedMenu,
		authButtons,
		login,
		isAuth,
		handleDropdownClick
	};
};
